export default "__VITE_ASSET__CyA61uZn__"